export default __webpack_public_path__ + "static/media/Frame 184 5.5ba4e0cc.png";